/**
 * アバターアイコンに表示する頭文字を返す。
 * Fluent の getInitials は日本語名でイニシャルを生成できないため、先頭の記号・空白を飛ばした
 * 最初の文字/数字を明示的に取り、英字は大文字に統一する。
 */
export const getAvatarInitial = (
  name: string | undefined
): string | undefined => name?.match(/[\p{L}\p{N}]/u)?.[0].toUpperCase();
